export const server ={
    // "url":"http://127.0.0.1:8000/",
    "prod":"https://gravitonweb.co.in/"
}